/**
 * 主界面中心底部组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
<template>
    <div class="footer">
			<div class="pull-right hidden-xs">
				 <span>版本号：</span> <span>{{version}}</span>
			</div>
			<!--Copyright ©版权归
			<a :href="companyUrl">{{company}}</a>所有-->
		</div>
</template>

<script> 
  import {mapState} from 'vuex'
  var config = require('config/config.js');
  export default {
    name: 'ContentFooter',
    data() {
      return {
         version:config.system.version,
         company:config.system.company,
         companyUrl:config.system.companyUrl
      }
    },
    computed:mapState({
    	versionNo:state=>state.global.versionNo
    }),
    beforeMount(){
    	this.version = this.versionNo
    	if(this.version==''){
    		this.getInfo()
    	}
    }, 
    methods:{
    	getInfo(){
    		const param = {
				last:0,
				source:1
			}
    		 this.$http.get(process.env.API_ROOT + '/noauth/timeline',{params:param})
			.then(res=>{
				this.version = res.body.data.versionName
			},res=>{
				this.$store.dispatch('openMainTip',res.body.message);
			})
			.catch(res=>{
				this.$store.dispatch('openMainTip','请求异常'); 
			})
    	} 
    }
  };
</script>


// WEBPACK FOOTER //
// ContentFooter.vue?6d32aa20